import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';

import localUtil from '../../lib/util';

import LazyImage from '../gui/lazyImage';

// function hasImage(img) {
//     return (util.isObject(img) && img.src);
// }

const ImageInfo = props => {
    const { image } = props;
    return (<>
        <div class='images-info d-flex flex-row flex-wrap justify-content-center'>
            <span class='text-muted me-1'>size:</span> {localUtil.formatFileSize(image.size)}
            {image.dimmensions && <>
                <span class='text-muted ms-3 me-1'>dimmensions:</span> {image.width}x{image.height}px
            </>}
            {image.encoding && <>
                <span class='text-muted ms-3 me-1'>encoding:</span> {image.encoding}
            </>}
            {image.mimetype && <>
                <span class='text-muted ms-3 me-1'>mimetype:</span> {image.mimetype}
            </>}
            {image.ext && <>
                <span class='text-muted ms-3 me-1'>ext:</span> {image.ext}
            </>}
            {image.s3XLargeLink && <>
            </>}
            {image.s3Link && <>
                <span class='text-muted ms-3 me-1'>Download:</span>
                <a class='mx-1' href={image.s3Link} target='_blank' rel='noopener noreferrer'>org</a> |
                <a class='mx-1' href={image.s3XLargeLink} target='_blank' rel='noopener noreferrer'>large</a> |
                <a class='mx-1' href={image.s3MediumLink} target='_blank' rel='noopener noreferrer'>small</a>
            </>}
        </div>
    </>);
};

@observer
class ImageScroller extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageIdx: props.imageIdx || 0,
            imageElementScale: 1,
            imageElementMaxScale: 5,
            start: {},
            isPinching: false,
            wheelResetTimer: null,
            showFullscreen: false,
        };
        this.activePinchEl = null;
        this.imageScrollerRef;
    }

    onClickFullscreen = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({ showFullscreen: true });
    }

    onCloseFullscreen = (e) => {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        this.setState({ showFullscreen: false });
    }

    trackCarouselScroll = (newIdx, direction) => {
        const { stores, id: articleId, images = [] } = this.props;
        if (stores && stores.appState && articleId && images.length > 1) {
            stores.appState.addUsageLog({
                type: 'feed_carousel_scroll',
                props: {
                    articleId,
                    imageIndex: newIdx,
                    totalImages: images.length,
                    direction, // 'swipe', 'left', 'right'
                },
                timestamp: Math.floor(new Date().getTime() / 1000),
            });
        }
    }

    scrollImages = (e) => {
        const { images = [], callback = () => {} } = this.props;
        if (!images || images.length === 0) return;
        const totalImages = images.length - 1;

        // scrollHeight: 705
        // scrollLeft: 564
        // scrollTop: 0
        // scrollWidth: 1692

        const { scrollLeft, scrollWidth, clientWidth } = e.target;
        const imageStep = clientWidth;
        const imageIdx = scrollLeft / imageStep;
        // console.log({ e, imageStep, imageIdx, scrollLeft, scrollWidth, clientWidth });

        const nearestInt = Math.round(imageIdx);
        const diff = Math.abs(nearestInt - imageIdx);
        // console.log({ nearestInt, diff });
        if (Number.isInteger(imageIdx) || diff < 0.1) {
            const prevIdx = this.state.imageIdx;
            this.setState({
                imageIdx: nearestInt,
            });
            callback(nearestInt);

            // Track carousel scroll (only when index actually changes)
            if (prevIdx !== nearestInt) {
                this.trackCarouselScroll(nearestInt, 'swipe');
            }
        }
    }

    scrollToImage = (imageIdx) => {
        const el = this.imageScrollerRef;
        if (!el) return;

        const targetX = el.clientWidth * imageIdx;
        const deltaX = targetX - el.scrollLeft;

        setTimeout(() => {
            el.scrollBy({
                top: 0,
                left: deltaX,
                behavior: 'smooth'
            });
        }, 200);
    }

    scrollLeft = () => {
        const el = this.imageScrollerRef;
        if (!el) return;
        const width = 0 - el.clientWidth;
        el.scrollBy({
            top: 0,
            left: width,
            behavior: 'smooth'
        });
    }

    scrollRight = () => {
        const el = this.imageScrollerRef;
        if (!el) return;
        const width = el.clientWidth;
        el.scrollBy({
            top: 0,
            left: width,
            behavior: 'smooth'
        });
    }

    onClickScrollLeft = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.scrollLeft();
    }

    onClickScrollRight = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.scrollRight();
    }

    distance = (event) => {
        return Math.hypot(
            event.touches[0].pageX - event.touches[1].pageX,
            event.touches[0].pageY - event.touches[1].pageY
        );
    }

    pinchZoomOnTouchStart = (e) => {
        if (e.touches.length !== 2) {
            // single finger should scroll page/carousel
            this.setState({ isPinching: false });
            return;
        }
        e.preventDefault();
        e.stopPropagation();

        const el = e.currentTarget;
        const rect = el.getBoundingClientRect();
        const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left;
        const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top;

        this.activePinchEl = el;
        this.activePinchEl.style.willChange = 'transform';
        this.activePinchEl.style.transformOrigin = `${centerX}px ${centerY}px`;

        this.setState({
            isPinching: true,
            imageElementScale: 1,
            start: {
                x: (e.touches[0].pageX + e.touches[1].pageX) / 2,
                y: (e.touches[0].pageY + e.touches[1].pageY) / 2,
                distance: this.distance(e),
                centerX,
                centerY
            }
        });
    }

    pinchZoomOnTouchMove = (e) => {
        if (!(this.state.isPinching && e.touches.length === 2 && this.activePinchEl)) return;

        e.preventDefault();
        e.stopPropagation();

        const { start, imageElementMaxScale } = this.state;
        const rawScale = e.scale ? e.scale : (this.distance(e) / start.distance);
        const scale = Math.min(Math.max(1, rawScale), imageElementMaxScale);

        const moveCenterX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
        const moveCenterY = (e.touches[0].pageY + e.touches[1].pageY) / 2;

        const deltaX = (moveCenterX - start.x) * 2;
        const deltaY = (moveCenterY - start.y) * 2;

        const el = this.activePinchEl;
        el.style.transition = '';
        el.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${scale})`;
        el.style.zIndex = '3';

        this.setState({ imageElementScale: scale });
    }

    pinchZoomOnTouchEnd = (e) => {
        // when touches drop below 2, end the pinch and restore scrolling
        if (!this.state.isPinching || e.touches.length >= 2) return;

        const el = this.activePinchEl || e.currentTarget;
        this.setState({ isPinching: false, imageElementScale: 1, start: {} });

        if (el) {
            el.style.transition = 'transform 200ms ease-out';
            el.style.transform = '';
            el.style.willChange = '';
            el.style.zIndex = '';
        }
        this.activePinchEl = null;
    }

    // helper
    resetZoom = (el) => {
        if (!el) return;
        el.style.transition = 'transform 200ms ease-out';
        el.style.transform = '';
        el.style.willChange = '';
        el.style.zIndex = '';
        this.setState({ isPinching: false, imageElementScale: 1 });
    }

    // wheel fallback (dev only)
    onWheelZoom = (e) => {
        // mac trackpad pinch -> wheel with ctrl/meta in many setups
        if (!(e.ctrlKey || e.metaKey)) return;
        e.preventDefault();

        const el = e.currentTarget;
        const rect = el.getBoundingClientRect();
        const originX = e.clientX - rect.left;
        const originY = e.clientY - rect.top;

        const { imageElementMaxScale } = this.state;
        const step = 0.12 * (e.deltaY < 0 ? 1 : -1); // pinch out/in
        const current = this.state.imageElementScale || 1;
        const next = Math.min(Math.max(1, current + step), imageElementMaxScale);

        el.style.willChange = 'transform';
        el.style.transformOrigin = `${originX}px ${originY}px`;
        el.style.transition = '';
        el.style.transform = `scale(${next})`;
        el.style.zIndex = '3';

        this.setState({ isPinching: true, imageElementScale: next });

        clearTimeout(this.state.wheelResetTimer);
        const wheelResetTimer = setTimeout(() => this.resetZoom(el), 180);
        this.setState({ wheelResetTimer });
    }



    // distance = (event) => {
    //     return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    // }

    // pinchZoomOnTouchStart = (event) => {
    //     // console.log('touchstart', event);
    //     if (event.touches.length === 2) {
    //         event.preventDefault(); // Prevent page scroll
    //         event.stopPropagation();

    //         // Calculate where the fingers have started on the X and Y axis
    //         const start = {};
    //         start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
    //         start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
    //         start.distance = this.distance(event);
    //         this.setState({ start });
    //     }
    // }

    // pinchZoomOnTouchMove = (event) => {
    //     // console.log('touchmove', event);
    //     let { imageElementScale, imageElementMaxScale } = this.state;
    //     const { start } = this.state;
    //     if (event.touches.length === 2) {
    //         event.preventDefault(); // Prevent page scroll
    //         event.stopPropagation();
    //         let scale;

    //         // Safari provides event.scale as two fingers move on the screen
    //         // For other browsers just calculate the scale manually
    //         if (event.scale) {
    //             scale = event.scale;
    //         } else {
    //         const deltaDistance = this.distance(event);
    //             scale = deltaDistance / start.distance;
    //         }

    //         imageElementScale = Math.min(Math.max(1, scale), imageElementMaxScale);
    //         this.setState({ imageElementScale }, () => {
    //             // Calculate how much the fingers have moved on the X and Y axis
    //             const deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2; // x2 for accelarated movement
    //             const deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2; // x2 for accelarated movement

    //             // Transform the image to make it grow and move with fingers
    //             const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
    //             event.target.style.transition = '';
    //             event.target.style.transform = transform;
    //             event.target.style.WebkitTransform = transform;
    //             event.target.style.zIndex = '100000';
    //             // event.target.style.maxHeight = '';
    //             // event.target.style.maxWidth = '';
    //         });

    //     }
    // }

    // pinchZoomOnTouchEnd = (event) => {
    //     // console.log('touchend', event);
    //     // Reset image to it's original format
    //     if (event.touches.length === 2) {
    //         this.setState({ imageElementScale: 1 });
    //         event.target.style.transition = 'transform 250ms';
    //         event.target.style.transform = '';
    //         event.target.style.WebkitTransform = '';
    //         event.target.style.zIndex = '';
    //     }
    //     // event.target.style.maxHeight = '75vh';
    //     // event.target.style.maxWidth = '100%';
    // }

    componentDidMount() {
        const { id, imageIdx, getRef = () => {} } = this.props;
        if (imageIdx) {
            this.scrollToImage(imageIdx);
        }
        getRef(this.imageScrollerRef, id);
    }

    componentWillReceiveProps(nextProps) {
        const { imageIdx } = nextProps;
        if (imageIdx !== this.props.imageIdx) {
            this.scrollToImage(imageIdx);
        }
    }

    render() {
        const { imageIdx, isPinching, imageElementScale, showFullscreen } = this.state;
        const {
            images = [],
            id,
            dblClick = () => {},
            onClick,
            onImageClick = () => {},
            likeRef = {},
            unlikeRef = {},
            noimagestext,
            minHeight = '100px',
            dotClasses,
            dotStyles,
            showImg,
            showLargeImage = () => {},
            hasImage = () => true,
            classWidth = 'w-100',
            classNames = '',
            classNamesWrapper1 = 'bg-light',
            showImageInfo = false,
            maxHeight = '30vh',
            maxWidth,
            wrapperMaxWidth,
            imageContainerStyles = '',
            imageStyles = '',
            rounded = true,
            onDoubleClick = () => {},
            showFullscreenButton = true,
            isFullscreenMode = false,
            fullscreenButtonStyle = 'top: 15px; right: 15px;',
        } = this.props;
        const { appState } = this.props.stores;
        const { isCordova } = appState;
        const hasPrev = imageIdx > 0;
        const hasNext = imageIdx < images.length - 1;

        if (!images || images.length === 0) {
            if (noimagestext) {
                return (<>
                    <div class='col-12 text-center text-muted'>
                        <div class='display-1'>
                            <i class='fas fa-camera' />
                        </div>
                        <h3 class='font-weight-lighter'>
                            {noimagestext}
                        </h3>
                    </div>
                </>);
            }
            return <></>;
        }

        if (images && images.length === 1) {
            const ImageScrollerFullscreen = showFullscreen ? require('../gui/imageScrollerFullscreen').default : null;
            return (<>
                <div
                    class={`${classWidth} position-relative ${classNames}`}
                    style={`${wrapperMaxWidth ? `max-width: ${wrapperMaxWidth};` : ''}`}
                >
                    <div class={`d-flex flex-row flex-nowrap ${classNamesWrapper1}`}>
                        <div
                            class={`w-100 h-100 text-center ${rounded ? 'rounded-lg' : ''} imageContainer d-flex justify-content-center align-items-center position-relative overflow-hidden`}
                            style={`max-height: ${maxHeight}; min-height: ${minHeight}; max-width: ${maxWidth}; ${imageContainerStyles}`}
                        >
                            <LazyImage
                                className='img-fluid position-relative'
                                src={showImg(images[0])}
                                alt={images[0].alt || images[0].aiAltText || images[0].name || ''}
                                lowResBase64={images[0].lowResBase64}
                                loading='lazy'
                                style={`max-height: ${maxHeight}; min-height: ${minHeight}; ${imageContainerStyles};`}
                                onTouchStart={this.pinchZoomOnTouchStart}
                                onTouchMove={this.pinchZoomOnTouchMove}
                                onTouchEnd={this.pinchZoomOnTouchEnd}
                                onTouchCancel={this.pinchZoomOnTouchEnd}
                                onClick={onImageClick}
                                onDoubleClick={onDoubleClick}
                                data-objectId={id}
                                data-md5={images[0].md5}
                                data-image={showImg(images[0])}
                                data-largeImage={showLargeImage(images[0])}
                            />
                        </div>
                    </div>
                    {showFullscreenButton && !isFullscreenMode && <div
                        class='position-absolute text-white px-1 py-1 rounded-lg'
                        style={`${fullscreenButtonStyle} background-color: rgba(0, 0, 0, 0.25); line-height: 1.0em; cursor: pointer; z-index: 2;`}
                        onClick={this.onClickFullscreen}
                    >
                        <small><i class='fas fa-expand' /></small>
                    </div>}
                    {showImageInfo && <ImageInfo image={images[0]} />}
                </div>
                {showFullscreen && ImageScrollerFullscreen && <ImageScrollerFullscreen
                    images={images}
                    stores={this.props.stores}
                    imageIdx={imageIdx}
                    onClickClose={this.onCloseFullscreen}
                />}
            </>);
        }

        return (
            <div
                class={`${classWidth} position-relative ${classNames}`}
                style={`${wrapperMaxWidth ? `max-width: ${wrapperMaxWidth};` : ''}`}
            >
                {/* <div
                    class={`d-flex flex-row flex-nowrap bg-light ${rounded ? 'rounded-lg' : ''} no-scrollbar ${classNames}`}
                    style={`
                        overflow-x: ${imageElementScale > 1 && images.length === 1 ? 'visible !important' : 'auto'};
                        overflow-y: ${imageElementScale > 1 ? 'visible !important' : 'auto'};
                        scroll-snap-type: x mandatory;
                    `}
                    onScroll={this.scrollImages}
                    ref={c => this.imageScrollerRef = c}
                > */}
                {/* isPinching: {isPinching ? 'true'a : 'false'} */}
                <div
                    class={`d-flex flex-row flex-nowrap bg-light ${rounded ? 'rounded-lg' : ''} no-scrollbar ${classNames}`}
                    style={`
                        overflow-x: ${isPinching ? 'hidden' : 'auto'};
                        overflow-y: hidden;
                        scroll-snap-type: ${isPinching ? 'none' : 'x mandatory'};
                    `}
                    onScroll={this.scrollImages}
                    ref={c => this.imageScrollerRef = c}
                >
                    {images && images.filter(hasImage).map((img, idx) => (
                        <div class='col-12 clearfix p-0' key={`image-scroller-${idx}`}>
                            <div
                                class={`w-100 h-100 text-center imageContainer d-flex justify-content-center align-items-center position-relative `}
                                style={`
                                    scroll-snap-align: start;
                                    flex-wrap: wrap;
                                `}
                                // overflow: ${imageElementScale > 1 ? 'visible !important' : 'hidden'};
                                onDblClick={dblClick}
                                onClick={onClick}
                                data-id={id}
                                // onTouchStart={e => { e.stopPropagation(); }}
                                // onTouchEnd={e => { e.stopPropagation(); }}
                                // onTouchMove={e => { e.stopPropagation(); }}
                            >
                                <div
                                    class='position-absolute w-100 h-100'
                                    style={`
                                        background-image: url('${img.lowResBase64 ? `data:image/jpeg;base64,${img.lowResBase64}` : showImg(img)}'); background-size: cover;
                                        filter: blur(10px);
                                        opacity: 0.5;
                                        pinter-events: none;
                                    `}
                                        // overflow-y: ${imageElementScale > 1 ? 'visible !important' : 'hidden'};
                                />
                                {img ? <LazyImage
                                    className='img-fluid position-relative'
                                    src={showImg(img)}
                                    alt={img.alt || img.aiAltText || img.name || ''}
                                    lowResBase64={img.lowResBase64}
                                    loading='lazy'
                                    style={`max-height: ${maxHeight}; min-height: ${minHeight}; ${imageContainerStyles};`}
                                    onTouchStart={this.pinchZoomOnTouchStart}
                                    onTouchMove={this.pinchZoomOnTouchMove}
                                    onTouchEnd={this.pinchZoomOnTouchEnd}
                                    onTouchCancel={this.pinchZoomOnTouchEnd}
                                    onClick={onImageClick}
                                    onDoubleClick={onDoubleClick}
                                    data-objectId={id}
                                    data-md5={img.md5}
                                    data-image={showImg(img)}
                                    data-largeImage={showLargeImage(img)}
                                /> : <>
                                    <span class='display-1 text-muted'>
                                        <i class='fas fa-camera' />
                                    </span>
                                </>}

                                {img.title && <div class='position-absolute w-100 text-center' style='bottom: 0px; background-color: rgba(0, 0, 0, 0.5);'>
                                    {img.title}
                                </div>}

                                {showImageInfo && <ImageInfo image={img} />}

                                {/* <xmp>{JSON.stringify(img, null, 4)}</xmp> */}
                            </div>
                            {likeRef[id] && <span class='likeHeart position-absolute text-white display-1' style='top: calc(50% - 50px); left: calc(50% - 50px); width: 100px; height: 100px;'>
                                <i class='fa-solid fa-heart likeStory' />
                            </span>}
                            {unlikeRef[id] && <span class='unlikeHeart position-absolute text-white display-1' style='top: calc(50% - 50px); left: calc(50% - 50px); width: 100px; height: 100px;'>
                                <i class='fa-solid fa-heart-crack unlikeStory' />
                            </span>}
                        </div>
                    ))}
                </div>
                {images && images.length > 1 && <>
                    <div
                        class={`w-100 text-center mt-0 ${dotClasses} position-absolute`}
                        style={`
                            bottom: 0px;
                            left: 0px;
                            ${dotStyles}
                        `}
                    >
                        <small>
                            <small>
                                {images && images.filter(hasImage).map((img, idx) => <>
                                    <i class={`${idx === imageIdx ? 'fa-solid' : 'fa-regular'} fa-circle me-1 text-muted`} />
                                </>)}
                            </small>
                        </small>
                    </div>
                    <div
                        class='position-absolute text-white font-weight-lighter px-1 py-1 rounded-lg'
                        style='top: 15px; left: 15px; background-color: rgba(0, 0, 0, 0.25); line-height: 1.0em;'
                    >
                        <small>{imageIdx + 1} / {images.length}</small>
                    </div>
                </>}

                {showFullscreenButton && !isFullscreenMode && <div
                    class='position-absolute text-white px-1 py-1 rounded-lg'
                    style={`${fullscreenButtonStyle} background-color: rgba(0, 0, 0, 0.25); line-height: 1.0em; cursor: pointer; z-index: 2;`}
                    onClick={this.onClickFullscreen}
                >
                    <small><i class='fas fa-expand' /></small>
                </div>}

                {isFullscreenMode ? <>
                    {hasPrev && <div
                        class='position-absolute'
                        style={`top: 50%; left: 5px;`}
                    >
                        <button type='button' class={`btn btn-link text-light`} style={`font-size: 2.2em; opacity: 0.5;`} onClick={this.onClickScrollLeft}><i class='fas fa-arrow-circle-left' /></button>
                    </div>}
                    {hasNext && <div
                        class='position-absolute'
                        style={`top: 50%; right: 5px;`}
                    >
                        <button type='button' class={`btn btn-link text-light`} style={`font-size: 2.2em; opacity: 0.5;`} onClick={this.onClickScrollRight}><i class='fas fa-arrow-circle-right' /></button>
                    </div>}
                </> : <>
                    {isCordova ? <></> : <>
                        {hasPrev && <div
                            class='position-absolute d-none d-lg-block'
                            style={`top: 50%; left: 5px;`}
                        >
                            <button type='button' class={`btn btn-link text-light`} style={`font-size: 2.2em; opacity: 0.5;`} onClick={this.onClickScrollLeft}><i class='fas fa-arrow-circle-left' /></button>
                        </div>}
                        {hasNext && <div
                            class='position-absolute d-none d-lg-block'
                            style={`top: 50%; right: 5px;`}
                        >
                            <button type='button' class={`btn btn-link text-light`} style={`font-size: 2.2em; opacity: 0.5;`} onClick={this.onClickScrollRight}><i class='fas fa-arrow-circle-right' /></button>
                        </div>}
                    </>}
                </>}

                {showFullscreen && (() => {
                    const ImageScrollerFullscreen = require('../gui/imageScrollerFullscreen').default;
                    return <ImageScrollerFullscreen
                        images={images}
                        stores={this.props.stores}
                        imageIdx={imageIdx}
                        onClickClose={this.onCloseFullscreen}
                    />;
                })()}

            </div>
        );
    }
}

export default ImageScroller;
